module.exports = __webpack_public_path__ + "img/space_invaders_record_front.acc3e434.jpg";